import React from "react";
import Header from "../../components/Header/Header";
import "./Settings.css";

const Settings = () => {
  return (
    <div>
      <Header />
      <div className="settings-page">
        <h1>Ayarlar</h1>
        <p className="settings-muted">Bu alan yakında aktif olacaktır.</p>
      </div>
    </div>
  );
};

export default Settings;
